const SOW_CREDIT_POOL_DEFINITIONS = [
    {
        type: 'pro_credit',
        label: 'Pro Credits',
        unitModes: ['credit'],
        selectableOnCreate: true,
    },
    {
        type: 'pulse_credit',
        label: 'Pulse Credits',
        unitModes: ['credit'],
        selectableOnCreate: true,
    },
    {
        type: 'professional_services_credit',
        label: 'Professional Services',
        unitModes: ['credit'],
        selectableOnCreate: true,
    },
    {
        type: 'userlytics_credit',
        label: 'Userlytics',
        unitModes: ['credit'],
        selectableOnCreate: true,
    },
    {
        type: 'token',
        label: 'Tokens',
        unitModes: ['token'],
        selectableOnCreate: true,
    },
];
export const DEFAULT_SOW_CREDIT_POOL_RESET_POLICY = Object.freeze({ type: 'none' });
export function listSowCreditPoolDefinitions() {
    return SOW_CREDIT_POOL_DEFINITIONS;
}
export function isSowCreditPoolType(value) {
    return SOW_CREDIT_POOL_DEFINITIONS.some((definition) => definition.type === value);
}
export function getSowCreditPoolDefinition(poolType) {
    return SOW_CREDIT_POOL_DEFINITIONS.find((definition) => definition.type === poolType);
}
export function getSowCreditPoolLabel(poolType) {
    return getSowCreditPoolDefinition(poolType)?.label;
}
export function isSowCreditPoolTypeAllowedForUnitMode(poolType, unitMode) {
    const definition = getSowCreditPoolDefinition(poolType);
    return definition !== undefined && definition.unitModes.some((mode) => mode === unitMode);
}
export function listSelectableSowCreditPools(unitMode) {
    return SOW_CREDIT_POOL_DEFINITIONS.filter((definition) => definition.selectableOnCreate && definition.unitModes.some((mode) => mode === unitMode));
}
export { periodicReleaseCurrentPeriodLabel, poolUsageReflectsCurrentPeriod, resolveSowPoolUsageDisplayMetrics, } from './sow-pool-usage-display.js';
//# sourceMappingURL=sow-credit-pools.js.map